export const selfServiceUrl =
  process.env.REACT_APP_SELF_SERVICE_URL ||
  "https://mishtest.zap360.co.il/Login";
export const ofirUrl = process.env.REACT_APP_OFIR_URL


export const recaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY;

export const shouldUseRecaptcha = process.env.REACT_APP_USE_RECAPTCHA === "1";

export const siteBaseUrl = process.env.REACT_APP_SITE_BASE_URL;

export const siteVersion = process.env.REACT_APP_SITE_VERSION;

export const restUrl = process.env.REACT_APP_REST_URL;
export const mishlohimUrl = process.env.REACT_APP_MISHLOHIM_URL;
export const dpzUrl = process.env.REACT_APP_DPZ_URL;
export const doctorsUrl = process.env.REACT_APP_DOCTORS_URL;
export const mitchatnimUrl = process.env.REACT_APP_MITCHATNIM_URL;

export const mishlohimImagesBaseUrl = process.env.REACT_APP_IMAGES_MISHLOHIM_BASE_URL;
export const netappUrl = process.env.REACT_APP_NETAPP_URL;


export const API_ENDPOINT = () => {
  let result = 
    process.env.REACT_APP_API_BASE_URL || "https://biz-api-dev.zap360.co.il";

  const apiHost = process.env.REACT_APP_API_HOST;

  if (apiHost) {
    const { location } = window;

    const fragments = location.host.split(".");
    const server = fragments[0];

    const serverNumber = parseInt(server, 10);

    if (!isNaN(serverNumber)) {
      result = `${location.protocol}//${fragments[0]}.${apiHost}`;
    }
  }

  return result;
};
